import { EMPTY_DETAIL_FIELD } from "web_myplann/Utils/constants";

export const formatEnumLabel = <E extends string>(
	value: E | undefined | null,
	noneValue: E,
	labelMap: Record<E, string>,
	t: (key: string) => string,
): string =>
	value && value !== noneValue ? t(labelMap[value]) : EMPTY_DETAIL_FIELD;
